import classNames from 'classnames'
import { MoveLeft } from 'lucide-react'
import { useNavigate } from 'react-router'

import './BackLink.scss'

interface BackLinkProps {
  text?: string;
  variant?: 'dark' | 'light';
  onBackOverride?: undefined | (() => void);
}

function BackLink({
  text,
  variant = 'dark',
  onBackOverride = undefined,
}: BackLinkProps) {
  const navigate = useNavigate()

  return (
    <button
      className={classNames('back-link', `back-link-${variant}`)}
      onClick={onBackOverride || (() => navigate(-1))}
    >
      <MoveLeft size={18} />
      {text || 'Back'}
    </button>
  )
}

export default BackLink
